<template>
  <li :class="isDropDown ? '' : 'nav-item'">
    <router-link :to="menuItem.link" :class="isDropDown ? 'dropdown-item' : ''">
      <template v-if="menuItem.icon">
        <span class="fontIcon"><font-awesome-icon :icon="menuItem.icon"></font-awesome-icon></span>
      </template>
      {{menuItem.label}}
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    menuItem: null,
    isDropDown: false
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menus/SideMenuNode.vue